<date-picker [options]="dateOptions" (valueChange)="datePickerChange($event)"></date-picker>
